
import { IPerformanceIndicatorAnswer } from '@/interfaces/performance_indicator';
import { endOfMonth, isWithinInterval, startOfMonth } from 'date-fns';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FilteredState extends Vue {
  @Prop({ type: Object, default: () => {} }) readonly allItems: object;

  questions = [{ selectedMonth: null, selectedState: null }];

  isResults(question: any) {
    const filteredResults = this.filterState(question.selectedMonth, question.selectedState);
    return Object.keys(filteredResults).length;
  }

  addQuestion() {
    this.questions.push({ selectedMonth: null, selectedState: null });
  }

  cleanItem() {
    return this.questions.pop();
  }

  filterState(month: number, state: any) {
    const items = this.allItems;
    const filteredAnswers: IPerformanceIndicatorAnswer = {};
    const now = new Date();

    for (const nameAnswer in items) {
      const campaignAnswers = items[nameAnswer].filter((answer: any) => {
        const eventDate = new Date(answer.answer_created_at);

        // Opcional
        let matchesMonth = true;
        if (month !== null) {
          const monthStart = startOfMonth(now.setMonth(month));
          const monthEnd = endOfMonth(now.setMonth(month));
          matchesMonth = isWithinInterval(eventDate, {
            start: monthStart,
            end: monthEnd,
          });
        }

        // Obrigatório
        let matchesState = answer.nome_uf === state;
        return matchesMonth && matchesState;
      });

      if (campaignAnswers.length > 0) {
        filteredAnswers[nameAnswer] = campaignAnswers;
      }
    }
    return filteredAnswers;
  }
}
